/**
 * Formula configuration utilities
 */

interface FormulaConfig {
    hideDiscounts?: boolean;
    hideCategoryDiamonds?: boolean;
}

declare global {
    interface Window {
        FORMULA_CONFIG?: FormulaConfig;
    }
}

/**
 * Check if discounts should be hidden based on formula settings
 */
export function hideDiscounts(): boolean {
    return window.FORMULA_CONFIG?.hideDiscounts === true;
}

/**
 * Check if category diamonds should be hidden based on formula settings
 */
export function hideCategoryDiamonds(): boolean {
    return window.FORMULA_CONFIG?.hideCategoryDiamonds === true;
}
